export default "__VITE_ASSET__womMomm5__"